import dictionary from './dictionary'
import dashboard from './dashboard'
import manage from './manage'
import report from './report'
import monitoring from './monitoring'

export default [...dashboard, ...manage, ...dictionary, ...report, ...monitoring]
